<template>
  <div class="box p-3">
    <div class="package__payment__method">
      <div class="container">
      <div class="package__payment__method__item mb-4">
        <h5 class="payment__item__title">Nạp tiền qua ngân hàng</h5>
      </div>
      <!-- Thông báo trạng thái khi nộp tiền tự do -->
        <div class="alert alert-warning text-center" role="alert">
          <p class="text-muted small font-italic">Hệ thống sẽ tự động xác nhận và cộng tiền vào ví của bạn! <br/>
            Quá trình xác nhận có thể kéo dài 1-2 phút sau khi bạn thực hiện chuyển khoản.<br/>Bạn có thể click vào nút <a href="#" @click.prevent="reloadPage" style="color: #007bff; text-decoration: underline; cursor: pointer;">reload</a> để cập nhật số dư mới nhất.
          </p>
        </div>
        <div class="row">
          <!-- Mã QR -->
          <div class="col-md-6 text-center">
            <div class="card p-3" style="height: 100%;">
              <img v-if="link" :src="link" class="img-fluid" alt="QR Code" />
            </div>
          </div>
          <!-- Thông tin ngân hàng -->
          <div class="col-md-6">
            <div class="card p-3" style="height: 100%;">
              <!-- Logo ngân hàng -->
              <div class="text-center">
                <img src="@/assets/images/MBBank.png" height="72" class="mb-2" alt="MBBank Logo" />
              </div>
              <!-- Thông tin ngân hàng -->
              <h5 class="text-muted small">Ngân hàng TMCP Quân đội (MB)</h5>
              <p class="mb-1 small">Chi nhánh: <strong></strong></p>
              <p class="mb-1 small">Chủ tài khoản: <strong>NGUYEN TRI HIEN</strong></p>
              <!-- Số tài khoản + Nút copy -->
              <p class="mb-0 small" style="cursor: pointer;" @click="copyText(accountNumber)">Số tài khoản: <strong>{{ accountNumber }}</strong>
                <svg class="ml-2" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
              </p>
              <!-- Nội dung chuyển khoản + Nút copy -->
              <p class="mb-0 small" style="cursor: pointer;" @click="copyText(contentPayQr)">Nội dung chuyển khoản: <strong>{{ contentPayQr }}</strong>
                <svg class="ml-2" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
              </p>
              <!-- Lưu ý -->
              <p class="text-muted font-italic mt-2" style="font-size: small;">
                *Lưu ý: Ghi đúng <strong>nội dung chuyển khoản</strong> để được tự động duyệt tiền. Nếu quên, vui
                lòng liên hệ
                CSKH.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center mt-3">Điện thoại hỗ trợ: <a href="tel:0969836599">0969.836.599</a> (từ 8h30 đến 17h30 các
        ngày)!
        Chúc bạn thành công!</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../_store/constants";

export default {
  name: "UserTopup",
  data() {
    return {
      method: 0,
      form: {
        amount: null,
        fullname: "",
        phone: "",
        email: "",
        delivery: "",
        address: "",
        ward: "",
        city: "",
        province: ""
      },
      provinces: [
        "Hà Nội",
        "Hồ Chí Minh",
        "An Giang",
        "Bà Rịa - Vũng Tàu",
        "Bắc Giang",
        "Bắc Kạn",
        "Bạc Liêu",
        "Bắc Ninh",
        "Bến Tre",
        "Bình Dương",
        "Bình Phước",
        "Bình Thuận",
        "Bình Định",
        "Cà Mau",
        "Cần Thơ",
        "Cao Bằng",
        "Gia Lai",
        "Hà Giang",
        "Hà Nam",
        "Hà Tĩnh",
        "Hải Dương",
        "Hải Phòng",
        "Hậu Giang",
        "Hoà Bình",
        "Hưng Yên",
        "Khánh Hòa",
        "Kiên Giang",
        "Kon Tum",
        "Lai Châu",
        "Lâm Đồng",
        "Lạng Sơn",
        "Lào Cai",
        "Long An",
        "Nam Định",
        "Nghệ An",
        "Ninh Bình",
        "Ninh Thuận",
        "Phú Thọ",
        "Phú Yên",
        "Quảng Bình",
        "Quảng Nam",
        "Quảng Ngãi",
        "Quảng Ninh",
        "Quảng Trị",
        "Sóc Trăng",
        "Sơn La",
        "Tây Ninh",
        "Thái Bình",
        "Thái Nguyên",
        "Thanh Hóa",
        "Thừa Thiên Huế",
        "Tiền Giang",
        "Trà Vinh",
        "Tuyên Quang",
        "Vĩnh Long",
        "Vĩnh Phúc",
        "Yên Bái",
        "Đà Nẵng",
        "Đắk Lắk",
        "Đắk Nông",
        "Điện Biên",
        "Đồng Nai",
        "Đồng Tháp"
      ],
      accountNumber: "516169369",
      link: undefined,
    };
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters({
      "cityList": `${STORE_KEY}/cityList`,
      "wardList": `${STORE_KEY}/wardList`,
    }),
    contentPayQr() {
      return `TKPWEB ${this.user.id} ${this.user.phone} nap tien tryhsk`;
    }
  },
  beforeMount() {},
  mounted() {
    setTimeout(() => {
      this.link = `https://img.vietqr.io/image/MB-516169369-compact2.png?addInfo=${this.contentPayQr}&accountName=NGUYEN%20TRI%20HIEN`;
    }, 1000);
  },
  methods: {
    ...mapActions(`${STORE_KEY}`, ["deposit", "getCities", "getWards"]),
    requestDeposit() {
      let data;
      if (this.method == 0) {
        data = {
          type: 1,
          amount: this.form.amount
        };
      } else {
        const city = this.cityList.find(item => item.id == this.form.city);
        const ward = this.wardList.find(item => item.id == this.form.ward);
        data = {
          type: 2,
          amount: this.form.amount,
          fullname: this.form.fullname,
          email: this.form.email,
          phone: this.form.phone,
          delivery_time: this.form.delivery,
          address: this.form.address,
          ward: ward.name,
          city: city.name,
          province: this.form.province
        };
      }

      this.deposit(data);
    },
    onProvinceChange(value) {
      this.form.city = '';
      this.getCities({
        province: value
      });
    },
    onCityChange(value) {
      this.getWards({
        city_id: value
      });
    },
    copyText(text) {
      navigator.clipboard.writeText(text)
        .then(() => { })
        .catch(() => {})
    },
    reloadPage() {
      window.location.reload();
    }
  }
};

</script>
<style>
.package__payment__method__content {
  display: flex;
  justify-content: space-between;
  box-shadow: inset 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.copied {
  background-color: #17a2b8 !important;
  /* Màu xanh */
  color: white !important;
  border-color: #17a2b8 !important;
}
</style>
